var exports = {
  "TJ": "HeroTabsBackgroundGrid__1G0ugn",
  "V6": "HeroTabsBackground__ELUxev",
  "G4": "RiverBreakoutTabsVisual__w7hfyC",
  "wd": "HeroTabsVideo__JPxoQ0",
  "Cs": "HeroTabsPoster__nSUJO1",
  "gD": "RiverBreakoutTabs__N_iDAG",
  "hR": "RiverBreakoutTabsItem__q3Fo4D",
  "lO": "cta__KpE_dp",
};

module.exports = exports;
